// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__48Syo","footer":"styles_footer__yvHzv","passCodeTooltip":"styles_passCodeTooltip__3XSjD"};